'use client'

import { ReactNode } from 'react'
import PlusIcon from '@/components/icons/PlusIcon'
import Card from '@/components/ui/Card'
import ContentWrapper from '@/components/ui/ContentWrapper'
import CTACard from '@/components/ui/CTACard'
import HomeAboutKommers from '@/modules/home/components/HomeAboutKommers'
import HomeBielefieldInfo from '@/modules/home/components/HomeBielefieldInfo'
import HomeInfiniteHorizonalPartnersLine from '@/modules/home/components/HomeInfiniteHorizonalPartnersLine'
import HomeOurProcess from '@/modules/home/components/HomeOurProcess'
import HomeOurCapabilities from '@/modules/home/our-capabilities/HomeOurCapabilities'
import PortfolioSlice from '@/modules/home/portfolio-slice/PortfolioSlice'
import SituationCards from '@/modules/situations/SituationCards'
import { useLocale, useTranslations } from 'next-intl'

const HomePage = ({ capabilities }: { capabilities?: ReactNode }) => {
  const t = useTranslations('home')
  const locale = useLocale()

  return (
    <div className="w-full">
      {/* Kein zweites h1: die sichtbare Hero-Headline in HomeHeader ist das einzige h1
          der Startseite. Der Markentext bleibt als sr-only-Kontext für Screenreader/SEO erhalten. */}
      <p className="sr-only">{t('hero.title')}</p>
      <HomeBielefieldInfo />
      <ContentWrapper tag="div" className="mt-12 lg:mt-16 grid-cols-4 lg:grid-cols-12 gap-8">
        <Card className="bg-white col-span-full mobile-m:col-span-2 p-8 break-word hyphens-auto">
          <PlusIcon size={20} color={'#ec4e20'} />
          <p className="text-KMRS-Darkmode mt-8 leading-6 text-lg">
            {t('hero.conception')} <br />
            {t('hero.design')} <br />
            {t('hero.technology')}
            <br />
          </p>
        </Card>

        <Card className="bg-KMRS-Darkmode border border-accent col-span-full mobile-m:col-span-2 p-8 break-word hyphens-auto">
          <PlusIcon size={20} color={'#ec4e20'} />
          <p className="text-white mt-8 leading-6 text-lg">
            {t('hero.locations.fuerth')} <br />
            {t('hero.locations.germany')} <br />
            {t('hero.locations.worldwide')} <br />
          </p>
        </Card>
      </ContentWrapper>
      <SituationCards locale={locale} variant="compact" />
      <PortfolioSlice />
      <HomeAboutKommers />
      <HomeInfiniteHorizonalPartnersLine />
      <HomeOurCapabilities>{capabilities}</HomeOurCapabilities>
      <HomeOurProcess />

      <ContentWrapper tag="div" className="grid-cols-4 lg:grid-cols-12 gap-8 *:col-span-6 mt-24 lg:mt-32 mb-16">
        <CTACard />
      </ContentWrapper>
    </div>
  )
}

export default HomePage
